import styled from 'styled-components';
import { createGlobalStyle } from 'styled-components';

// Global styles for search field area (CSS-in-JS)
export const SearchFieldAreaStyles = createGlobalStyle`
    .serach_field-area .search-label {
        width: 100% !important;
        margin-bottom: 0 !important;
        flex: 1 1 0% !important;
        min-width: 0 !important;
    }
    
    .serach_field-area .search_field {
        display: flex !important;
        align-items: center !important;
        gap: 8px !important;
        padding: 0 14px !important;
        position: relative !important;
    }
    
    .serach_field-area .search_field input {
        border: none !important;
        outline: none !important;
        box-shadow: none !important;
        flex: 1 1 0% !important;
        min-width: 0 !important;
        width: 100% !important;
        font-size: 16px !important;
        font-family: Inter !important;
        font-weight: 400 !important;
        color: #101828 !important;
        background: transparent !important;
        height: 100% !important;
        min-height: 46px !important;
        line-height: 24px !important;
        padding: 11px 0 11px 0 !important;
        margin: 0 !important;
        position: relative !important;
        z-index: 1 !important;
    }
    
    .serach_field-area .search_field input:focus,
    .serach_field-area .search_field input:active,
    .serach_field-area .search_field input:focus-visible {
        border: none !important;
        outline: none !important;
        box-shadow: none !important;
    }
    
    .serach_field-area .search_field input::placeholder {
        opacity: 0 !important;
    }
    
    .serach_field-area .search_field__fake-placeholder {
        position: absolute;
        left: 42px;
        top: 50%;
        transform: translateY(-50%);
        color: #98A2B3;
        font-family: Inter;
        font-size: 16px;
        font-weight: 400;
        line-height: 24px;
        pointer-events: none;
        z-index: 1;
        transition: opacity 0.2s ease;
    }
    
    .serach_field-area .search_field__fake-placeholder.hidden {
        opacity: 0;
        pointer-events: none;
    }
`;

// Container components
export const TableContainer = styled.div`
    position: relative;
`;

export const ContentTableWrapper = styled.div`
    width: 100%;
`;

// Filter header
export const FilterHeaderContainer = styled.div`
    display: flex;
    justify-content: space-between;
    align-items: center;
    padding: 1rem 0;
    border-top: 1px solid #E4E7EC;
    gap: 1rem;
    flex-wrap: wrap;
    min-width: 0;
`;

// Search section
export const SearchFieldArea = styled.div`
    margin-left: 0;
    flex-shrink: 0;
    width: auto;
    max-width: 100%;
`;

export const SearchInner = styled.div`
    width: 100%;
    flex-shrink: 0;
`;

export const SearchField = styled.div`
    display: flex;
    width: 320px;
    min-width: 0;
    max-width: 100%;
    height: 46px;
    padding: 0;
    flex-direction: row;
    align-items: center;
    justify-content: flex-start;
    border-radius: 10px;
    border: 1px solid #D0D5DD;
    background: #FFF;
    position: relative;
    box-sizing: border-box;
`;

export const SearchFieldInner = styled.div`
    display: flex;
    align-items: center;
    width: 100%;
    height: 100%;
    padding: 0 14px;
    gap: 8px;
    min-width: 0;
    position: relative;
`;

export const SearchIconContainer = styled.div`
    flex-shrink: 0;
    z-index: 2;
    position: absolute;
    left: 14px;
    top: 50%;
    transform: translateY(-50%);
    display: flex;
    align-items: center;
    justify-content: center;
`;

export const SearchInputContainer = styled.div`
    flex: 1 1 0%;
    min-width: 0;
    width: 100%;
    position: relative;
`;

export const FakePlaceholder = styled.span`
    position: absolute;
    left: 42px;
    top: 50%;
    transform: translateY(-50%);
    color: #98A2B3;
    font-family: Inter;
    font-size: 16px;
    font-weight: 400;
    line-height: 24px;
    pointer-events: none;
    z-index: 1;
    transition: opacity 0.2s ease;
`;

export const ClearButton = styled.div`
    cursor: pointer;
    display: flex;
    align-items: center;
    flex-shrink: 0;
    z-index: 2;
`;

// Selection row renderer
export const SelectionRowWrapper = styled.div`
    display: flex;
    justify-content: center;
    align-items: center;
    height: 100%;
`;

// Pagination
export const PaginationWrapper = styled.div`
    margin-left: auto;
    display: flex;
    justify-content: flex-end;
    margin-top: 1rem;
`;

// Column formatters
export const FoodItemCellWrapper = styled.div`
    display: flex;
    align-items: center;
    height: 100%;
    padding: 8px 0;
`;

